import Typography from '@nubank/nuds-web/components/Typography/Typography';
import styled from 'styled-components';

export const TextBreakTypography = styled(Typography)`
  word-break: normal;
  overflow-wrap: anywhere;
`;

TextBreakTypography.displayName = 'TextBreakTypography';
